import store from '@/store'
import GeofenceAutocomplete from '@/components/Autocompletes/GeofenceAutocomplete'
import VehicleTypeAutocomplete from '@/components/Autocompletes/VehicleTypeAutocomplete'
import CommodityAutocomplete from '@/components/Autocompletes/CommodityAutocomplete'
import CommodityVarietyAutocomplete from '@/components/Autocompletes/CommodityVarietyAutocomplete'
import EditFieldMeta from '@/components/ShippingOrders/EditFieldMeta'
import EditFieldOrderServices from '@/components/ShippingOrders/EditFieldOrderServices'
import OrderExternalId from '@/components/ShippingOrders/ListItemExternalId'
import OrderGeofence from '@/components/ShippingOrders/ListItemGeofence'
import OrderShippingsAmount from '@/components/ShippingOrders/ListItemShippingsAmount'
import { BFormInput } from 'bootstrap-vue'

const metaShippingTemplate = {
  estimated_pickup_date: null,
  estimated_delivery_date: null,
  pickup_note: null,
  delivery_note: null
}

export default {
  data() {
    return {
      vehicleTypeGroupVehicleTypesHash: '',
      commodityVarietiesHash: '',
      referenceLocation: null,
      orderServicesValue: [],
      item: {}
    }
  },
  computed: {
    shippingOrdersModelFull() {
      return {
        title: 'Shipping Orders',
        endpoint: this.$appConfig.api.baseUrl + 'carriers/' + this.profile.company_id + '/shipping-orders',
        noIdLink: true,
        allowSelect: false,
        fields: [
          {
            key: 'id',
            label: this.$gettext('ID'),
            editable: false
          },
          {
            key: 'external_id',
            label: this.$gettext('External ID'),
            description: 'The External System ID',
            editable: false,
            columnFilter: 'text',
            component: (value, key, item) => {
              return {
                is: OrderExternalId,
                order: item
              }
            }
          },
          {
            key: 'origin_location',
            label: this.$gettext('Source Location'),
            description: 'Origin Geofence of the order',
            editable: true,
            component: (value, key, item) => {
              return {
                is: OrderGeofence,
                order: item,
                checkpoint: 'origin'
              }
            },
            componentEdit: (value, key, item) => {
              return {
                is: GeofenceAutocomplete,
                props: {
                  required: true,
                  restrictTo: this.referenceLocation,
                  restrictToLevels: [0],
                  preQuery: item[key] || null,
                  withPreview: true,
                  previewData: item.origin,
                  checkFor: (element) => {
                    return element.geo_fences?.length > 0 && element.geo_points?.length > 0
                  },
                  includes: ['geo_type', 'geo_fences', 'geo_points'],
                  hasErrorsMessage: this.$gettext('The location lacks of needed child elements'),
                  selectedSearchItemProp: item.origin || null
                },
                on: {
                  selected: (result) => {
                    this.item = item
                    item[key] = result.external_id
                    if (this.ecosystemConfig?.modelOverrides?.referenceLocations?.options?.indexOf(result.reference_location.toUpperCase()) !== -1) {
                      item.reference_location = result.reference_location.toUpperCase()
                    } else {
                      item.reference_location = null
                    }
                    if (result.external_id.indexOf('GMS') === -1) {
                      item.is_from_third_party = true
                    } else {
                      item.is_from_third_party = false
                    }
                    if (!item.id) {
                      this.commodityVarietiesHash = JSON.stringify(result.meta?.commodity?.commodity_varieties)
                      store.commit('setCommodityVarieties', result.meta?.commodity?.commodity_varieties)
                      item.commodity = result.meta?.commodity
                      item.commodity_id = result.meta?.commodity_id
                      item.commodity_variety = result.meta?.commodity_variety
                      item.commodity_variety_id = result.meta?.commodity_variety_id
                    }
                  }
                }
              }
            },
            columnFilter: 'text'
          },
          {
            key: 'destination_location',
            label: this.$gettext('Destination Location'),
            description: 'Destination Geofence of the order',
            editable: true,
            component: (value, key, item) => {
              return {
                is: OrderGeofence,
                order: item,
                checkpoint: 'destination'
              }
            },
            componentEdit: (value, key, item) => {
              return {
                is: GeofenceAutocomplete,
                props: {
                  required: true,
                  restrictToLevels: [0],
                  preQuery: value || null,
                  withPreview: true,
                  previewData: item.destination,
                  checkFor: (element) => {
                    return element.geo_fences?.length > 0 && element.geo_points?.length > 0
                  },
                  includes: ['geo_type', 'geo_fences', 'geo_points'],
                  hasErrorsMessage: this.$gettext('The location lacks of needed child elements'),
                  selectedSearchItemProp: item.destination || null
                },
                on: {
                  selected: (result) => {
                    item[key] = result.external_id
                  }
                }
              }
            }
          },
          {
            key: 'vehicle_type_id',
            label: this.$gettext('Equipment Type'),
            editable: true,
            componentEdit: (value, key, item) => {
              return {
                is: VehicleTypeAutocomplete,
                props: {
                  required: (item.status !== 'draft'),
                  preQuery: item.vehicle_type ? item.vehicle_type.name : null,
                  item: item
                },
                on: {
                  selected: (result) => {
                    if (result) {
                      item[key] = result.id
                    } else {
                      item[key] = null
                    }
                  }
                }
              }
            },
            formatter: (value, key, item) => {
              let html = ''
              if (item.vehicle_type) {
                html = `<strong>${item.vehicle_type.name || item.vehicle_type.id}</strong>`
                html += item.vehicle_type_group.external_id || item.vehicle_type_group.description || item.vehicle_type_group.id ? `<br>(${item.vehicle_type_group.external_id || item.vehicle_type_group.description || item.vehicle_type_group.id})` : ''
              }
              return html
            }
          },
          {
            key: 'commodity_id',
            label: this.$gettext('Commodity'),
            editable: true,
            componentEdit: (value, key, item) => {
              if (item.commodity && JSON.stringify(item.commodity.commodity_varieties) !== this.commodityVarietiesHash) {
                console.log('setting Commodity Varities on LOAD')
                this.commodityVarietiesHash = JSON.stringify(item.commodity.commodity_varieties)
                store.commit('setCommodityVarieties', item.commodity.commodity_varieties)
              }
              return {
                is: CommodityAutocomplete,
                props: {
                  placeholder: this.$gettext('Reference, or External ID'),
                  required: true,
                  preQuery: item.commodity ? (item.commodity.external_id || item.commodity.reference) : null
                },
                on: {
                  selected: (result) => {
                    item[key] = result.id
                    item['commodity_variety_id'] = null
                    console.log('setting Commodity Varities on SELECT')
                    store.commit('setCommodityVarieties', result.commodity_varieties)
                  }
                }
              }
            },
            formatter: (value, key, item) => {
              return item.commodity?.external_id || item.commodity?.reference || item.commodity?.id
            }
          },
          {
            key: 'commodity_variety_id',
            label: this.$gettext('Variety'),
            editable: true,
            componentEdit: (value, key, item) => {
              return {
                is: CommodityVarietyAutocomplete,
                props: {
                  preQuery: item.commodity_variety ? (item.commodity_variety.external_id || item.commodity_variety.reference) : '',
                  minCharacter: 2
                },
                on: {
                  selected: (result) => {
                    if (result) {
                      item[key] = result.id
                    } else {
                      item[key] = null
                    }
                  }
                }
              }
            },
            formatter: (value, key, item) => {
              return item.commodity_variety?.external_id || item.commodity_variety?.reference || item.commodity_variety?.id || ''
            }
          },
          {
            key: 'shippings_amount',
            label: this.$gettext('Shipments Amnt.'),
            description: this.$gettext('The amount of shipments to ask for the Order'),
            editable: true,
            default: 1,
            component: (value, key, item) => {
              return {
                is: OrderShippingsAmount,
                order: item
              }
            },
            componentEdit: (value, key, item) => {
              return {
                is: BFormInput,
                props: {
                  required: true,
                  size: 'sm',
                  type: 'number',
                  min: 1
                },
                on: {
                  input: (value) => {
                    item[key] = value
                    if (value && parseInt(value) > 0) {
                      let diff
                      if (parseInt(value) > item.meta.shippings.length) {
                        diff = parseInt(value) - item.meta.shippings.length
                        for (let i = 0; i < diff; i++) {
                          item.meta.shippings.push({...metaShippingTemplate})
                        }
                      } else if (parseInt(value) < item.meta.shippings.length) {
                        diff = item.meta.shippings.length - parseInt(value)
                        item.meta.shippings.splice(item.meta.shippings.length - diff, diff)
                      }
                    }
                  }
                }
              }
            }
          },
          {
            key: 'delivery_date',
            label: this.$gettext('Delivery Date'),
            description: this.$gettext('The estimated Delivery Date'),
            editable: true,
            formatter: (value, key, item) => {
              return this.$options.filters.tabledate(value, this.$tz, this.frontConfig.i18n.moment)
            },
            type: 'date',
            required: true,
            props: {
              formatter: (value, event) => {
                let item = event.target.__vue__.$parent.item
                console.log(value, event.target.__vue__.$parent.item)
                if (item.pickup_date && this.moment.tz(value, this.$tz) < this.moment.utc(item.pickup_date).tz(this.$tz)) {
                  item.delivery_date = this.moment.utc(item.pickup_date).utc().format('YYYY-MM-DD HH:mm:ss')
                  return this.moment.utc(item.pickup_date).tz(this.$tz).format('YYYY-MM-DD')
                } else {
                  if (this.moment(value) < this.moment()) {
                    item.delivery_date = this.moment().utc().format('YYYY-MM-DD HH:mm:ss')
                    return this.moment().format('YYYY-MM-DD')
                  } else {
                    item.delivery_date = this.moment(value + ' 23:59:59').utc().format('YYYY-MM-DD HH:mm:ss')
                    return value
                  }
                }
              }
            }
          },
          {
            key: 'delivery_note',
            label: this.$gettext('Delivery Note'),
            type: 'textarea',
            editable: true,
            default: '',
            props: {
              rows: 3,
              maxRows: 5
            }
          },
          {
            key: 'pickup_date',
            label: this.$gettext('Pickup Date'),
            description: this.$gettext('The Pickup Date'),
            sortable: true,
            editable: true,
            formatter: (value, key, item) => {
              return this.$options.filters.tabledate(value, this.$tz, this.frontConfig.i18n.moment)
            },
            type: 'date',
            props: {
              formatter: (value, event) => {
                let item = event.target.__vue__.$parent.item
                console.log(value, event.target.__vue__.$parent.item)
                if (item.delivery_date && this.moment.tz(value, this.$tz) > this.moment.utc(item.delivery_date).tz(this.$tz)) {
                  item.pickup_date = this.moment.utc(item.delivery_date).utc().format('YYYY-MM-DD HH:mm:ss')
                  return this.moment.utc(item.delivery_date).tz(this.$tz).format('YYYY-MM-DD')
                } else {
                  if (this.moment(value) < this.moment()) {
                    item.pickup_date = this.moment().utc().format('YYYY-MM-DD HH:mm:ss')
                    return this.moment().format('YYYY-MM-DD')
                  } else {
                    item.pickup_date = this.moment(value + ' 23:59:59').utc().format('YYYY-MM-DD HH:mm:ss')
                    return value
                  }
                }
              }
            }
          },
          {
            key: 'pickup_note',
            label: this.$gettext('Pickup Note'),
            type: 'textarea',
            editable: true,
            default: '',
            props: {
              rows: 3,
              maxRows: 5
            }
          },
          {
            key: 'instructions',
            label: this.$gettext('Instructions'),
            description: 'Some Order instructions',
            type: 'textarea',
            editable: true,
            props: {
              rows: 3,
              maxRows: 5
            }
          },
          {
            key: 'status',
            label: this.$gettext('Status'),
            description: 'The Order status',
            type: 'select',
            options: [
              {
                text: this.$gettext('Draft'),
                value: 'draft'
              },
              {
                text: this.$gettext('Pending'),
                value: 'pending'
              },
              {
                text: this.$gettext('Confirmed'),
                value: 'confirmed',
                disabled: true
              },
              {
                text: this.$gettext('Error'),
                value: 'error',
                disabled: true
              },
              {
                text: this.$gettext('Canceled'),
                value: 'canceled'
              },
              {
                text: this.$gettext('Done'),
                value: 'done'
              }
            ],
            editable: true,
            default: 'draft'
          },
          {
            key: 'order_services',
            label: this.$gettext('Order Services'),
            description: this.$gettext('Special Services attached to the Order'),
            editable: true,
            default: this.orderServicesValue,
            componentEdit: (value, key, item) => {
              this.orderServicesValue = item[key]
              return {
                is: EditFieldOrderServices,
                props: {
                  placeholder: this.$gettext('Reference, or External ID')
                },
                on: {
                  selected: (result) => {
                    item[key] = result
                  }
                }
              }
            },
            formatter: (value, key, item) => {
              let html = ''
              for (const service of value) {
                html += `<span class="badge mr-1 badge-secondary">${service.external_id || service.reference}</span>`
              }
              return html
            }
          },
          {
            key: 'meta',
            label: this.$gettext('Extra Data'),
            editable: true,
            default: {
              shippings: [
                {...metaShippingTemplate}
              ],
              purchase_orders: ['']
            },
            waitForValue: true,
            componentEdit: (value, key, item) => {
              return {
                is: EditFieldMeta,
                props: {
                  order: item
                }
              }
            }
          }
        ],
        includes: [
          'origin.geo_type',
          'origin.geo_fences.geo_type',
          'origin.geo_lines.geo_type',
          'origin.geo_points.geo_type',
          'destination.geo_type',
          'destination.geo_fences.geo_type',
          'destination.geo_lines.geo_type',
          'destination.geo_points.geo_type',
          'vehicle_type_group.vehicle_types',
          'vehicle_type',
          'commodity.commodity_varieties',
          'commodity_variety',
          'order_services',
          'shippings'
        ],
        exclude: [
          'vehicle_type_group_id',
          'meta'
        ]
      }
    }
  }
}
